import React, { useMemo } from "react";
import DataTable from "../../_Components/DataTable";
import _ from "lodash";
import SwalMessage from "../../_Components/SwalMessage";
import { Button } from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";
import SplitNumber from "../../_Components/SplitNumber";
import CancelOrderModal from "./Component/CancelOrderModal";
import ApiBasketItemPerson from "../../../../core/api/api.basketItemPerson";
function DataGridUsedPromoCodeByUser({
  data,
  setSelectedCheckBoxes,
  selectedCheckBoxes,
}) {
  const [showModalCancle, setShowModalCancle] = useState(false);
  const [loading, setLoading] = useState([]); // روی دکمه ثبت

  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = data.data.map((item) => item.id);
      setSelectedCheckBoxes(allIds);
    } else {
      setSelectedCheckBoxes([]);
    }
  };

  const handleToggle = (id, event) => {
    setSelectedCheckBoxes((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };

  const handleShowModal = () => {
    if (selectedCheckBoxes == 0) {
      SwalMessage({
        title: "ابتدا آیتم های مورد نظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
    } else {
      setShowModalCancle(true);
    }
  };
  const handleDownloadFile = async (file) => {
    try {
      setLoading({ itemId: file.id, state: true });
      let obj = {
        id: file.basketItemId,
        fileId: file.id,
        access: 3,
      };
      let rest = await ApiBasketItemPerson.getFile(obj).then((response) => {
        if (response.type == "text/plain") {
          let myblob = new Blob([response]);
          myblob.text().then((text) => {
            SwalMessage({ title: text, iSsuccess: false, timer: 15000 });
          });
        } else {
          const fileBlobUrl = URL.createObjectURL(new Blob([response]));
          const anchor = document.createElement("a");
          anchor.style.display = "none";
          anchor.id = file.fileName + Math.floor(Math.random() * 100);
          anchor.href = fileBlobUrl;
          anchor.download = file.fileName;
          document.body.appendChild(anchor);
          anchor.click();
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading({ itemId: file.id, state: false });
    }
  };

  const columns = useMemo(() => [
    {
      accessor: "o",
      Header: "",
      minWidth: 50,
      Cell: ({ row }) => (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={selectedCheckBoxes.includes(row.original.id)}
            onChange={() => {}}
            onClick={(e) => handleToggle(row.original.id, e)}
          />

         {row.original.amusementServiceReserveItemIssueTicketType == 2 && <Link
            to={`/ticket/${row.original.basketItemId}`}
            className="me-1"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={18}
              height={18}
            >
              <path
                fill="currentColor"
                d="M7 9.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m0 2a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1M19.5 6H18V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V6H4.5A2.5 2.5 0 0 0 2 8.5V15a3.003 3.003 0 0 0 3 3h1v3.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18h1a3.003 3.003 0 0 0 3-3V8.5A2.5 2.5 0 0 0 19.5 6M7 3h10v3H7zm10 18H7v-6h10zm4-6a2.003 2.003 0 0 1-2 2h-1v-2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V17H5a2.003 2.003 0 0 1-2-2V8.5A1.5 1.5 0 0 1 4.5 7h15A1.5 1.5 0 0 1 21 8.5z"
              />
            </svg>
          </Link>}
          {row.original?.itemFiles?.map((file) => (
            <span
              className="text-primary ml-2 cursor-pointer"
              onClick={(e) => handleDownloadFile(file)}
            >
              <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={18}
              height={18}
            >
              <path
                fill="currentColor"
                d="M7 9.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m0 2a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1M19.5 6H18V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V6H4.5A2.5 2.5 0 0 0 2 8.5V15a3.003 3.003 0 0 0 3 3h1v3.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18h1a3.003 3.003 0 0 0 3-3V8.5A2.5 2.5 0 0 0 19.5 6M7 3h10v3H7zm10 18H7v-6h10zm4-6a2.003 2.003 0 0 1-2 2h-1v-2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V17H5a2.003 2.003 0 0 1-2-2V8.5A1.5 1.5 0 0 1 4.5 7h15A1.5 1.5 0 0 1 21 8.5z"
              />
            </svg>
            </span>
          ))}
        </div>
      ),
    },
    // {
    //   accessor: "_id",
    //   Header: "ردیف",
    //   minWidth: 50,
    // },

    {
      accessor: "id",
      Header: "شماره بلیط",
      minWidth: 100,
    },
    {
      accessor: "basketId",
      Header: "شماره سفارش",
      minWidth: 100,
    },
    {
      accessor: "createdPersianTime",
      Header: "تاریخ صدور",
      minWidth: 100,
    },
    {
      accessor: "basketUserFullName",
      Header: "نام و نام خانوادگی",
      minWidth: 150,
      Cell: ({ row }) => (
        <>
          <div>{row.original.basketUserFullName}</div>
          <div className="ltr">{row.original.mobile}</div>
        </>
      ),
    },
    // {
    //   accessor: "d",
    //   Header: "شهر",
    //   minWidth: 50,
    // },
    {
      accessor: "basketItemAmusementServiceName",
      Header: "برنامه گذار",
      minWidth: 100,
    },
    {
      accessor: "basketItemAmusementServiceReserveItemTitle",
      Header: "برنامه / سانس",
      minWidth: 250,
      Cell: ({ row }) => (
        <>
          <div>
            {row.original.basketItemAmusementServiceReserveItemTitle} -{" "}
            {row.original.basketItemAmusementServiceReserveItemGroupTitle}
          </div>
        </>
      ),
    },
    // {
    //   accessor: "createdTimeBasketItem",
    //   Header: "تاریخ",
    //   minWidth: 100,
    // },
    {
      accessor: "basketItemOriginalPrice",
      Header: "نرخ مصوب",
      minWidth: 100,
      Cell: ({ row }) => (
        <div style={{ textDecoration: "line-through" }}>
          <SplitNumber number={row.original.basketItemOriginalPrice} />
        </div>
      ),
    },
    {
      accessor: "basketItemSalePrice",
      Header: "نرخ فروش",
      minWidth: 100,
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.basketItemSalePrice} />
        </div>
      ),
    },
    // {
    //   accessor: "agentCommisionPrice",
    //   Header: "کمیسیون",
    //   minWidth: 100,
    //   Cell: ({ row }) => (
    //     <div>
    //       <SplitNumber number={row.original.agentCommisionPrice} />
    //     </div>
    //   ),
    // },
    {
      accessor: "amount",
      Header: "مبلغ نهایی",
      minWidth: 100,
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.amount} />
        </div>
      ),
    },
    // {
    //   accessor: "f",
    //   Header: "مانده",
    //   minWidth: 100,
    //   Cell: ({ row }) => (
    //     <>
    //       <div>مبلغی که مانده</div>
    //       <div>سیستم</div>
    //     </>
    //   ),
    // },
    {
      accessor: "basketItemCheckInDate",
      Header: "تاریخ استفاده",
      minWidth: 100,
    },
    {
      accessor: "currentStatus",
      Header: "وضعیت",
      align: "center",
      minWidth: 100,
      Cell: ({ row }) => (
        <div
          className={` rounded-pill px-2 py-1 d-flex justify-content-center ${
            row.original.currentStatus === "رهاسازی" ||
            row.original.currentStatus === "جدید"
              ? "bg-light-primary text-primary"
              : row.original.currentStatus === "در_حال_پیگیری"
                ? "bg-light-info text-info"
                : row.original.currentStatus === "انجام_شده"
                  ? "bg-light-success text-success"
                  : row.original.currentStatus === "انجام_نشده"
                    ? "bg-light-danger text-danger"
                    : ""
          }`}
        >
          {row.original.currentStatus === "رهاسازی"
            ? "جدید"
            : row.original.currentStatus}
        </div>
      ),
    },
    {
      accessor: "cancelStatus",
      Header: "وضعیت کنسلی",
      align: "center",
      minWidth: 100,
      Cell: ({ row }) => (
        <div
          className={` rounded-pill px-2 py-1 d-flex justify-content-center ${
            row.original.cancelStatus === "درخواست_کنسلی"
              ? "bg-light-primary text-primary"
              : row.original.cancelStatus === "پیگیری_کنسلی"
                ? "bg-light-info text-info"
                : row.original.cancelStatus === "کنسل_شد"
                  ? "bg-light-danger text-danger"
                  : row.original.cancelStatus === "رد_درخواست_کنسلی"
                    ? "bg-light-warning text-warning"
                    : ""
          }`}
        >
          {row.original.cancelStatus === "جدید" ||
          row.original.cancelStatus === "رهاسازی"
            ? "-"
            : row.original.cancelStatus}
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <div
        xs="12"
        className="px-0 py-3 d-flex align-items-center mt-4 mb-2 border rounded-3 bg-light"
      >
        <div className="form-check form-check-inline pr-0">
          <input
            id="selectAll"
            type="checkbox"
            checked={
              data?.data?.length > 0 &&
              selectedCheckBoxes.length === data?.data?.length
            }
            onChange={(e) => handleSelectAll(e.target.checked)}
          />
          <label className="form-check-label pl-1" for="selectAll">
            همه
          </label>
        </div>
        <div className="form-check form-check-inline pr-0">
          <input
            id="UnselectAll"
            className="form-check-input"
            type="checkbox"
            checked={selectedCheckBoxes.length === 0}
            onChange={() => {
              handleSelectAll(false);
              setSelectedCheckBoxes([]);
            }}
          />
          <label className="form-check-label pl-1" for="UnselectAll">
            هیچ کدام
          </label>
        </div>
        <Button
          variant="primary"
          className="py-1 me-2"
          onClick={handleShowModal}
        >
          درخواست استرداد
        </Button>
      </div>
      <DataTable config={config} columns={columns} data={data} />
      {showModalCancle && (
        <CancelOrderModal
          showModalCancle={showModalCancle}
          setShowModalCancle={setShowModalCancle}
          selectedCheckBoxes={selectedCheckBoxes}
          // item={itemForCancleModal}
        />
      )}
    </div>
  );
}

export default DataGridUsedPromoCodeByUser;
